import React from "react";
import ReactDOM from "react-dom";
import { compose, withState, lifecycle, renderNothing } from "recompose";

const LARGE_BREAKPOINT = 1024;
const IPHONE_SE_MAX_WIDTH = 375;
const IPHONE_SE_MAX_HEIGHT = 667;
const IPHONE_SE_PAN_UP_PX = 78;

export const enhance = compose(
	withState("infoWindow", "setInfoWindow", null),
	lifecycle({
		componentDidMount() {
			const { content, google, map, setInfoWindow, location, onClose } =
				this.props;

			if (google && map && location) {
				const infoContent = document.createElement("div");
				ReactDOM.render(<div>{content}</div>, infoContent);

				const viewportWidth = window.innerWidth;
				const viewportHeight = window.innerHeight;
				const isLargeView = viewportWidth >= LARGE_BREAKPOINT;
				const isIphoneSEViewport =
					viewportWidth <= IPHONE_SE_MAX_WIDTH &&
					viewportHeight <= IPHONE_SE_MAX_HEIGHT;

				const infoWindow = new google.maps.InfoWindow({
					content: infoContent,
					position: new google.maps.LatLng(
						location.latitude,
						location.longitude
					),
					pixelOffset: new google.maps.Size(0, isLargeView ? 485 : 455)
				});

				google.maps.event.addListener(infoWindow, "closeclick", onClose);
				setInfoWindow(infoWindow);
				infoWindow.open(map);

				if (isIphoneSEViewport && typeof map.panBy === "function") {
					setTimeout(() => {
						map.panBy(0, IPHONE_SE_PAN_UP_PX);
					}, 400);
				}
			}
		},
		componentWillUnmount() {
			const { google, infoWindow, setInfoWindow } = this.props;

			if (infoWindow) {
				infoWindow.close();
				google.maps.event.clearInstanceListeners(infoWindow);
				setInfoWindow(null);
			}
		}
	})
);

export default enhance(renderNothing());
